import React, { Component } from "react";
import { Table, Modal } from "react-bootstrap";
var dateFormat = require("dateformat");
class TermsandConditionViewModel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const data =
      this.props.TermsandConditionDtls && this.props.TermsandConditionDtls.item
        ? this.props.TermsandConditionDtls &&
          this.props.TermsandConditionDtls.item
        : null;
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>
                  Terms & Conditions Details
                </span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td>Terms Url</td>
                        <td>
                          {data !== null && data.termsUrl}
                        </td>
                      </tr>
                      <tr>
                        <td>Terms Version</td>
                        <td>
                          {data !== null && data.termsV}
                        </td>
                      </tr>
                      <tr>
                        <td>Privacy Url</td>
                        <td>
                          {data !== null && data.privacyUrl}
                        </td>
                      </tr>
                      <tr>
                        <td>Privacy Version</td>
                        <td>
                          {data !== null && data.privacyV}
                        </td>
                      </tr>
                      <tr>
                        <td>Created Date</td>
                        <td>
                          {data !== null &&
                            dateFormat(data.createdAt, "mediumDate")}
                        </td>
                      </tr>
                      <tr>
                        <td>Updated Date</td>
                        <td>
                          {data !== null &&
                            dateFormat(data.updatedAt, "mediumDate")}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default TermsandConditionViewModel;
